import React from "react";
import classes from "./searchSuggestions.module.scss";
import { SearchSuggestion, SUGGESTION_ICON } from "../constants/searchCategories";

interface SearchSuggestionsProps {
    suggestions: SearchSuggestion[];
    /** Run the completed query. */
    onPick: (text: string) => void;
}

/**
 * Suggest-as-you-type: the places, services and aliases the word being typed
 * could become, each a complete query — "Jordan med" → Medical Evacuation.
 */
const SearchSuggestions: React.FC<SearchSuggestionsProps> = ({ suggestions, onPick }) => {
    if (suggestions.length === 0) return null;
    return (
        <div className={classes.row} role="listbox" aria-label="Complete with">
            <span className={classes.label}>Complete</span>
            {suggestions.map((suggestion) => (
                <button
                    key={`${suggestion.kind}:${suggestion.label}`}
                    type="button"
                    role="option"
                    aria-selected={false}
                    className={`btn-unstyled ${classes.chip}`}
                    title={`Search "${suggestion.text}"`}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => onPick(suggestion.text)}
                >
                    <i className={`bi ${SUGGESTION_ICON[suggestion.kind]}`} />
                    {suggestion.label}
                    {suggestion.detail && <span className={classes.detail}>{suggestion.detail}</span>}
                </button>
            ))}
        </div>
    );
};

export default SearchSuggestions;
